import React from 'react';
import { Paperclip, Mic, MicOff, Send, X, Image as ImageIcon } from 'lucide-react';

export default function InputArea({
  fileInputRef, attached, onClearAttached, onPickFile, onFileChange,
  recording, onStartRecording, onStopRecording,
  input, setInput, onSend, loading, nome,
}) {
  return (
    <div className="border-t border-slate-200 p-3 bg-white rounded-b-md">
      <input ref={fileInputRef} type="file" onChange={onFileChange} className="hidden" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt" />
      {attached && (
        <div className="flex items-center gap-2 bg-primary border border-primary rounded px-2 py-1 mb-2 text-xs" data-testid="attached-file">
          {attached.is_image ? <ImageIcon size={12} className="text-primary" /> : <Paperclip size={12} className="text-primary" />}
          <span className="flex-1 truncate font-semibold text-slate-700">{attached.nome_file}</span>
          <button onClick={onClearAttached} className="text-red-500 hover:bg-red-100 rounded p-0.5"><X size={10} /></button>
        </div>
      )}
      <div className="flex items-end gap-2">
        <button onClick={onPickFile} data-testid="attach-file-btn" disabled={loading}
          className="p-2.5 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-700 disabled:opacity-40"
          title="Allega foto o documento">
          <Paperclip size={16} />
        </button>
        <button onClick={recording ? onStopRecording : onStartRecording}
          data-testid={recording ? "stop-recording" : "start-recording"}
          className={`p-2.5 rounded-full transition-all ${recording ? 'bg-red-500 text-white animate-pulse' : 'bg-slate-100 hover:bg-slate-200 text-slate-700'}`}
          title={recording ? "Ferma registrazione" : "Parla"}>
          {recording ? <MicOff size={16} /> : <Mic size={16} />}
        </button>
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); onSend(); } }}
          placeholder={recording ? 'Registrazione in corso...' : `Scrivi a ${nome}... (o usa la voce)`}
          rows="1"
          data-testid="assistant-input"
          disabled={recording}
          className="flex-1 resize-none text-sm border border-slate-300 rounded-md px-3 py-2 focus:outline-none focus:border-primary max-h-24" />
        <button onClick={() => onSend()} disabled={!input.trim() || loading} data-testid="send-btn"
          className="p-2.5 rounded-full bg-primary text-white disabled:opacity-40 hover:bg-primary/90">
          <Send size={16} />
        </button>
      </div>
    </div>
  );
}
